// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { provideJupyterDesignSystem, jpAccordionItem } from '@jupyter/web-components';
import { provideReactWrapper } from '@microsoft/fast-react-wrapper';
import React from 'react';
const { wrap } = provideReactWrapper(React, provideJupyterDesignSystem());
export const AccordionItem = wrap(jpAccordionItem(), { events: { onChange: 'change' } });
// @ts-expect-error unknown property
AccordionItem.displayName = 'Jupyter.AccordionItem';
